<section class="signature-pad">
  <div class="signature-pad__toolbar">
    <button
      type="button"
      class="signature-pad__icon-btn"
      (click)="clear()"
      aria-label="Limpiar firma"
    >
      <i class="fa-solid fa-eraser"></i>
    </button>
  </div>

  <canvas
    #canvasRef
    class="signature-pad__canvas"
    (pointerdown)="startDrawing($event)"
    (pointermove)="draw($event)"
    (pointerup)="endDrawing()"
    (pointercancel)="endDrawing()"
    (pointerleave)="endDrawing()"
  ></canvas>
</section>
